<template>
  <lt-ui-form contendPadding="0px" style="border-width:0px;">
    <el-form ref="form" :model="form" label-width="60px">
      <el-row>
        <el-col>
          <el-form-item label="x" prop="x">
            <el-input v-model="form.x">
              <el-button
                slot="prepend"
                icon="icon icon-minus green"
                @click="handleXDesc"
              ></el-button>
              <el-button
                slot="append"
                icon="icon icon-plus green"
                @click="handleXIncrese"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="y" prop="y">
            <el-input v-model="form.y">
              <el-button
                slot="prepend"
                icon="icon icon-minus green"
                @click="handleYDesc"
              ></el-button>
              <el-button
                slot="append"
                icon="icon icon-plus green"
                @click="handleYIncrese"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="w" prop="w">
            <el-input v-model="form.w">
              <el-button
                slot="prepend"
                icon="icon icon-minus green"
                @click="handleWDesc"
              ></el-button>
              <el-button
                slot="append"
                icon="icon icon-plus green"
                @click="handleWIncrese"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="h" prop="h">
            <el-input v-model="form.h">
              <el-button
                slot="prepend"
                icon="icon icon-minus green"
                @click="handleHDesc"
              ></el-button>
              <el-button
                slot="append"
                icon="icon icon-plus green"
                @click="handleHIncrese"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="旋转角度" prop="Angle">
            <el-input v-model="form.Angle">
              <el-button
                slot="prepend"
                icon="icon icon-minus green"
                @click="handleADesc"
              ></el-button>
              <el-button
                slot="append"
                icon="icon icon-plus green"
                @click="handleAIncrese"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </lt-ui-form>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      default() {
        return null;
      },
    },
    ifChange: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    formData: function(newValue) {
      if (newValue != null && newValue != undefined) {
        if (newValue.target.cellType != undefined) {
          this.form.x = newValue.target.geometry.x;
          this.form.y = newValue.target.geometry.y;
          this.form.w = newValue.target.geometry.width;
          this.form.h = newValue.target.geometry.height;
          var state = newValue.parent.getView().getState(newValue.target);
          debugger;
          this.form.Angle = state.shape.rotation;
          this.form.cellType =
            newValue.target.cellType == undefined
              ? ""
              : newValue.target.cellType;
        }
      }
    },
    form: {
      handler: function(newVal, oldVal) {
        var propertyData = {
          data: newVal,
          type: "Arrange",
        };
        if (this.ifChange) {
          return;
        }
        this.$emit("ArrangeChange", propertyData);
      },
      deep: true,
    },
  },
  data() {
    return {
      form: {
        x: 0, //横坐标
        y: 0, //纵坐标
        w: 0, //宽
        h: 0, //高
        Angle: 0, //旋转角度
        cellType: "", //元素类别
      },
    };
  },
  methods: {
    getFormData() {
      //返回页面数据
      return this.form;
    },
    handleXDesc() {
      if (this.form.x > 0) {
        this.form.x--;
      }
    },
    handleXIncrese() {
      this.form.x++;
    },
    handleYDesc() {
      if (this.form.y > 0) {
        this.form.y--;
      }
    },
    handleYIncrese() {
      this.form.y++;
    },
    handleWDesc() {
      if (this.form.w > 5) {
        this.form.w--;
      }
    },
    handleWIncrese() {
      this.form.w++;
    },
    handleHDesc() {
      if (this.form.h > 5) {
        this.form.h--;
      }
    },
    handleHIncrese() {
      this.form.h++;
    },
    handleADesc() {
      if (this.form.Angle == 0) {
        this.form.Angle = 359;
      } else {
        this.form.Angle--;
      }
    },
    handleAIncrese() {
      if (this.form.Angle == 359) {
        this.form.Angle = 0;
      } else {
        this.form.Angle++;
      }
    },
  },
  beforeMount() {},
  mounted() {},
};
</script>

<style scoped>
.ltui-panel.ltui-form >>> .ltui-panel__content {
  overflow: hidden !important;
}
</style>
